import { render, staticRenderFns } from "./LeftTextBorderMany.vue?vue&type=template&id=894750d4&scoped=true"
import script from "./LeftTextBorderMany.vue?vue&type=script&lang=js"
export * from "./LeftTextBorderMany.vue?vue&type=script&lang=js"
import style0 from "./LeftTextBorderMany.vue?vue&type=style&index=0&id=894750d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894750d4",
  null
  
)

export default component.exports